import type { BillingStatDTO } from '../subscriptionBillingStat.types';

export class BillingStatModel {
  private readonly _dto: BillingStatDTO;

  constructor(dto: BillingStatDTO) {
    this._dto = dto;
  }

  get originDTO(): BillingStatDTO {
    return this._dto;
  }

  get annualPaymentEstimate() {
    return this._dto.annualPaymentEstimate;
  }

  get monthlyPaymentAmountEstimate() {
    return this._dto.monthlyPaymentEstimate;
  }

  get annualBillingAmountEstimate() {
    return this._dto.annualBillingAmountEstimate;
  }

  get monthlyBillingAmountEstimate() {
    return this._dto.monthlyBillingAmountEstimate;
  }
}
